module.exports = __webpack_public_path__ + "media/mosaics/Mosaics-Room-Hallway-7ca88386.jpg";